import { gql } from '@apollo/client';

export type ReturnMethod = {
  __typename: 'RestReturnMethod';
  name: string;
  value: number;
};

export type ReturnSummary = {
  __typename: 'RestReturnSummary';
  id: string;
  attributes: {
    __typename: 'RestReturnSummmaryAttributes';
    countryCode: string;
    currencyUnit: string;
    orderNumber: string;
    refundDetails: {
      __typename: 'RestRefundDetails';
      amount: string;
      paymentMethod: string;
    }[];
    returnMethods: ReturnMethod[];
    returnMethodId: number;
    returnOptionId: number;
    returnReasonHash: { [id: string]: number };
    selectedItemIds: string[];
    shipmentNumber: string | null;
    taxes: string | number;
    taxDetails: {
      __typename: 'RestReturnSummaryTaxDetails';
      taxType: string;
      refundable: boolean;
    };
    totalRefundAmount: string | number;
  };
};

export type GetReturnSummaryQueryVariables = {
  shipmentNumber?: string;
  orderNumber?: string;
  countryCode: string;
};

export type GetReturnSummaryQuery = {
  getReturnSummary: {
    __typename: 'RestReturnSummaryPayload';
    data: ReturnSummary[];
  };
};

export const RETURN_SUMMARY_FRAGMENT = gql`
  fragment ReturnSummaryFragment on RestReturnSummary {
    id
    attributes @type(name: "RestReturnSummmaryAttributes") {
      countryCode: country_code
      currencyUnit: currency_unit
      orderNumber: order_number
      refundDetails: refund_summary_details @type(name: "RestRefundDetails") {
        amount
        paymentMethod: payment_method
      }
      returnMethods: return_method_details @type(name: "RestReturnMethod") {
        name
        value
      }
      returnMethodId: return_method_id
      returnOptionId: return_option_id
      returnReasonHash: return_reason_hash
      selectedItemIds: selected_item_ids
      shipmentNumber: shipment_number
      taxes
      taxDetails: tax_details @type(name: "RestReturnSummaryTaxDetails") {
        taxType: tax_type
        refundable
      }
      totalRefundAmount: total_refund_amount
    }
  }
`;

export const GET_RETURN_SUMMARY_QUERY = gql`
  query GetReturnSummaryQuery(
    $shipmentNumber: String
    $orderNumber: String
    $countryCode: String!
  ) {
    getReturnSummary(
      shipment_number: $shipmentNumber
      order_number: $orderNumber
      country_code: $countryCode
    )
      @rest(
        type: "RestReturnSummaryPayload"
        endpoint: "return_summary"
        path: "/v3.5/return_summary?{args}"
      ) {
      data @type(name: "RestReturnSummary") {
        ...ReturnSummaryFragment
      }
    }
  }
  ${RETURN_SUMMARY_FRAGMENT}
`;
